import {
  beRecipientGetGroupDetails,
  beRecipientGetListOfGroupDetails,
  GROUP_TYPE_TEST,
  GROUPS_SEARCH_TYPE_ECONTAINS
} from 'Api/beRecipientApi'
import { GROUP_MAX_ITEMS } from 'Hooks/useModalEndCondition/useModalEndCondition'

import { STORE_KEY_ID_LIST, storeGet } from 'mailup-react-helpers'

const makeGroupItem = ({ Id, Name }) => ({
  label: `${Id} - ${Name}`,
  value: Id
})

export const getGroups = async (searchBy = '', groupType = undefined) => {
  const idList = storeGet(STORE_KEY_ID_LIST)
  let params = {
    orderBy: 'Id',
    orderDescending: true,
    pageSize: GROUP_MAX_ITEMS,
    groupType: groupType === GROUP_TYPE_TEST ? GROUP_TYPE_TEST : undefined
  }
  if (searchBy) {
    params = { ...params, searchBy, searchType: GROUPS_SEARCH_TYPE_ECONTAINS }
  }

  const { Items, TotalItems } = await beRecipientGetListOfGroupDetails(
    idList,
    params
  )

  return {
    items: Items.map((o) => makeGroupItem(o)),
    totalItems: TotalItems
  }
}

export const getGroupById = async (idGroup) => {
  const result = await beRecipientGetGroupDetails(idGroup)

  return result ? makeGroupItem(result) : null
}

export { GROUP_TYPE_TEST }
